import styled from '@emotion/styled';
import { UDText } from 'ud-ui/components';

const CELL_SIZE = 70;

export const MatrixContainer = styled.div`
  overflow-x: auto;
  padding-bottom: 10px;
`;

export const MatrixTable = styled.div<{ size: number }>`
  display: grid;
  grid-template-columns: ${CELL_SIZE}px repeat(${({ size }) => size}, 1fr);
  grid-template-rows: repeat(${({ size }) => size}, 1fr) 80px;
  gap: 4px;
  width: fit-content;
`;

export const Cell = styled.div<{
  bgColor?: string;
  isSelf?: boolean;
  isSplit?: boolean;
}>`
  width: ${CELL_SIZE}px;
  height: ${CELL_SIZE}px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${({ bgColor, isSelf, isSplit, theme }) => {
    if (isSelf) return theme.colors.WhiteGray60;
    if (isSplit) return 'transparent';
    return bgColor || theme.colors.SurfaceWhite;
  }};
  border-radius: 4px;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.DarkBlue};
  text-align: center;
  padding: ${({ isSplit }) => (isSplit ? '0' : '4px')};
  gap: ${({ isSplit }) => (isSplit ? '2px' : '0')};
  overflow: hidden;
`;

export const MatchInfoWrapper = styled.div<{ bgColor?: string }>`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${({ bgColor, theme }) => bgColor || theme.colors.SurfaceWhite};
  border-radius: 4px;
`;

export const SplitHalf = styled.div`
  width: 100%;
  height: calc(50% - 1px);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  & > div {
    border-radius: 4px;
  }
`;

export const TeamLogoCell = styled(Cell)`
  background-color: ${({ theme }) => theme.colors.SurfaceWhite};
  img {
    max-width: 40px;
    max-height: 40px;
    object-fit: contain;
  }
`;

export const MatchResult = styled(UDText)``;

export const MatchDate = styled(UDText)`
  margin-top: 2px;
`;

export const EmptyCell = styled(Cell)`
  background-color: transparent;
`;
